import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { Locale } from 'vant'
import viVN from 'vant/lib/locale/lang/vi-VN'
import zhCN from 'vant/lib/locale/lang/zh-CN'
import enUS from 'vant/lib/locale/lang/en-US'
import jaJP from 'vant/lib/locale/lang/ja-JP'

import viMessages from './vi'
import zhCNMessages from './zh-CN'
import enMessages from './en'
import jaMessages from './ja'
import koMessages from './ko'
import ruMessages from './ru'

Vue.use(VueI18n)

// 项目对外语言 key 与 vant 语言码的映射
// vant 2.12.27 内置 vi-VN / zh-CN / en-US / ja-JP
// 韩/俄无内置 vant 包，统一用 en-US 兜底（业务文案仍用对应语言）
const VANT_LANG_MAP = {
	en: 'en-US',
	'zh-CN': 'zh-CN',
	vi: 'vi-VN',
	ja: 'ja-JP',
	ko: 'en-US',
	ru: 'en-US',
}
const VANT_BUNDLES = {
	'vi-VN': viVN,
	'zh-CN': zhCN,
	'en-US': enUS,
	'ja-JP': jaJP,
}

export const SUPPORTED_LANGS = ['en', 'zh-CN', 'vi', 'ja', 'ko', 'ru']
export const DEFAULT_LANG = 'en'
// 切换面板选项（name 用各语言母语显示，便于用户识别）
export const LANG_OPTIONS = [
	{ name: 'English', lang: 'en' },
	{ name: '简体中文', lang: 'zh-CN' },
	{ name: 'Tiếng Việt', lang: 'vi' },
	{ name: '日本語', lang: 'ja' },
	{ name: '한국어', lang: 'ko' },
	{ name: 'Русский', lang: 'ru' },
]

function getInitialLang() {
	const saved = localStorage.getItem('lang')
	if (saved && SUPPORTED_LANGS.includes(saved)) return saved
	return DEFAULT_LANG
}
function applyVantLocale(lang) {
	const vantLang = VANT_LANG_MAP[lang]
	if (vantLang && VANT_BUNDLES[vantLang]) {
		Locale.use(vantLang, VANT_BUNDLES[vantLang])
	}
}

const i18n = new VueI18n({
	locale: getInitialLang(),
	fallbackLocale: DEFAULT_LANG,
	messages: {
		en: enMessages,
		'zh-CN': zhCNMessages,
		vi: viMessages,
		ja: jaMessages,
		ko: koMessages,
		ru: ruMessages,
	},
	silentTranslationWarn: true,
})

// 初始化时同步 vant
applyVantLocale(i18n.locale)

// 切换语言的统一入口（供组件调用）
export function setLang(lang) {
	if (!SUPPORTED_LANGS.includes(lang)) return
	i18n.locale = lang
	applyVantLocale(lang)
	localStorage.setItem('lang', lang)
}

export default i18n
